import { Client, Databases } from "appwrite";
import conf from "../conf/conf";

const client = new Client()
  .setEndpoint(conf.appwrite_url)
  .setProject(conf.appwrite_project_id);

export const databases = new Databases(client);

export const APPWRITE_DB_ID = conf.appwrite_database_id;
export const APPWRITE_JOBS_COLLECTION_ID = conf.appwrite_jobs_collection_id;
export const APPWRITE_SUBSCRIPTIONS_COLLECTION_ID =
  conf.appwrite_subscription_collection_id;
export const APPWRITE_SAVEDJOBS_COLLECTION_ID =
  conf.appwrite_savedjobs_collection_id;
export const APPWRITE_HACKATHON_COLLECTION_ID =
  conf.appwrite_hackathon_collection_id;
export const APPWRITE_BLOGS_COLLECTION_ID = conf.appwrite_blogs_collection_id;
export const APPWRITE_PROMPT_FUNCTION_ID = conf.appwrite_prompt_function_id;
